import { API, setAuthToken } from '../../../config/API.js';
import { GET_E_MAGAZINE, SET_LOADING_E_MAGAZINE, SET_PAGINATION_E_MAGAZINE } from '../constant.js';

export const getEMagazine = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_E_MAGAZINE,
      payload: true,
    });
    API.get(`admin/magazine?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_E_MAGAZINE,
          payload: res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_E_MAGAZINE,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_E_MAGAZINE,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_E_MAGAZINE,
          payload: 0,
        });
      });
  };
};

export const addEMagazine = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/magazine/add", params);
};

export const getDetailEMagazine = (id) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get("admin/magazine/" + id);
};

export const updEMagazine = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/magazine/edit", params);
};

export const delEMagazine = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/magazine/delete/" + code);
};
